import { z } from 'zod';
import { isValid as isValidIBAN } from 'iban';
import { zodUploadedFileMetadataSchema } from '../../../types/forms';

/**
 * NB!
 * If you need to change the schema, please also update the backend repository as it uses the same schema.
 * Otherwise the backend will reject the requests.
 */

const contactInfoSchema = z.object({
  name: z.string().min(1),
  address: z.string().min(1),
  zip: z.string().min(1),
  city: z.string().min(1),
  phone: z.string().min(1),
  email: z.string().email(),
  iban: z.string().refine((val) => isValidIBAN(val)),
});

const eventSchema = z.object({
  name: z.string().min(1),
  location: z.string().min(1),
  travelRoute: z.string().min(1),
});

const publicExpenseReport = z.object({
  date: z.string().min(1),
  time: z.string().min(1),
  vehicle: z.string().min(1),
  amount: z.number().min(0.01),
  receipts: z.union([z.custom<FileList>(), z.array(zodUploadedFileMetadataSchema), z.undefined()]),
  additionalInformation: z.string(),
});

const ownCarExpenseReport = z.object({
  date: z.string().min(1),
  time: z.string().min(1),
  numberOfPeople: z.number().min(1),
  totalKm: z.number().min(1),
  additionalInformation: z.string(),
});

export const schema = z.object({
  contactInfo: contactInfoSchema,
  event: eventSchema,
  publicExpenseReports: z.array(publicExpenseReport).optional(),
  ownCarExpenseReports: z.array(ownCarExpenseReport).optional(),
});

export type TravelExpenseReportFormState = z.infer<typeof schema>;
